import TopLevelAwait from "../../../../local/source/shared/top-level-await.mdx";
import IntegrationTable from "../../../../local/source/shared/integration-table.mdx";
import * as React from 'react';
export default {
  TopLevelAwait,
  IntegrationTable,
  React
};